export const init = () => {
  document.querySelectorAll('.js-open-map-modal').forEach((el) => {
    el.addEventListener('click', (event) => {
      window.triggerMapModal();

      App.track.all({
        category: 's-room-map',
        action: 'click-top-link',
        label: event.currentTarget.textContent.trim(),
      });
    });
  });

  document.querySelectorAll('.js-open-reviews-modal, .js-track-modal-open').forEach((el) => {
    el.addEventListener('click', () => {
      window.triggerShowReviewsModal();
    });
  });

  // data tracking
  $(document).on('click', '.js-open-reviews-modal', () => {
    App.track.all({
      category: 's-room-review',
      action: 'click',
      label: 'room-reviews',
    });

    App.track.all({
      category: 's-room-review',
      action: 'click',
      label: 'room-reviews-top-link',
    });
  });
};
